import type { ObservableQuery } from "@apollo/client";

const wait = (milliseconds: number) =>
  new Promise((res) => setTimeout(res, milliseconds));
export const delayRefetchedQuery = async (observableQuery: ObservableQuery) => {
  await wait(500);
  observableQuery.refetch();
};
